import showKeyEditorModal from './showKeyEditorModal'
import { EditOutlined } from '@ant-design/icons'
import { notification, Tooltip } from 'antd'
import { transformError } from 'Components/errorMessages'
import WeaverService from 'Services/WeaverService'

InlineKeyEditor = ({ label, type }) ->

  currentKey = label.replace(/ *\([^)]*\) */g, "")

  handleIconClick = ->
    if !WeaverService.userCanEdit()
      notification.error({
        style: {whiteSpace: 'pre-wrap'}
        message: transformError.message
        description: transformError.descriptuon
        duration: 10
      })
    else
      showKeyEditorModal(currentKey, type)

  <Tooltip
    mouseEnterDelay={1}
    title="Edit #{currentKey}"
    placement="right"
  >
    <EditOutlined
      style={{color: '#888'} if !WeaverService.userCanEdit()}
      data-testid="edit-attr-and-rel-key-icon-#{label}"
      onClick={handleIconClick}
    />
  </Tooltip>

export default InlineKeyEditor
